import { Component, signal, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { User } from '@services/user.service';
import { Router } from '@services/route.service';
import { Menu } from '@components/partials/menu/menu';
import { Menu as MenuService } from '@services/menu.service';
import { ScanCard } from '@components/partials/scan/scan-card/scan-card';
import { UiModule } from '@components/ui/ui-module';

@Component({
  selector: 'lgb-root',
  imports: [
    RouterModule,
    Menu,
    ScanCard,
    UiModule
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App{
  protected readonly title = signal('Legend-Binder');
  private readonly user=inject(User);
  private readonly router=inject(Router);
  readonly menu=inject(MenuService);

  constructor(){
    this.router.data$()
      .subscribe((data: {overrideConnect?: boolean}) => {
        if(!this.user.isConnected() && !data.overrideConnect)
          this.router.navigate('login');
      });
  }
}
